export default {"src":"/_next/static/media/circle-1.cd30b07b.svg","height":341,"width":232};